import { render, staticRenderFns } from "./GetInvolved.vue?vue&type=template&id=fb890be6&"
import script from "./GetInvolved.vue?vue&type=script&lang=js&"
export * from "./GetInvolved.vue?vue&type=script&lang=js&"
import style0 from "./GetInvolved.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VThemeProvider } from 'vuetify/lib/components/VThemeProvider';
installComponents(component, {VThemeProvider})
